module.exports = __webpack_public_path__ + "img/category-casino.39c702e1.png";